import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import MembersContext from '../../../application/Context/MembersContext';
export var InfoBar = function () {
    var count = useContext(MembersContext).count;
    var t = useTranslation(['news']).t;
    React.useEffect(function () {
    }, []);
    return (_jsx("div", { className: "under-filter-info", children: _jsxs("div", { children: [" ", count, " ", t("éléments")] }) }));
};
